/**
 * Helpers for country / state dropdowns (used with `/v1/address/countries` & `/states`).
 */

/** Default country when the country field is hidden (non-address forms). */
export const DEFAULT_ADDRESS_COUNTRY = "India";

export function resolveCountryIso2(countries, countryValue) {
  if (!countryValue || !Array.isArray(countries) || countries.length === 0) {
    return null;
  }
  const raw = String(countryValue).trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  if (raw.length === 2) {
    const byCode = countries.find((c) => String(c.iso2).toLowerCase() === lower);
    if (byCode) return String(byCode.iso2).toUpperCase();
  }
  const byName = countries.find((c) => String(c.name).toLowerCase() === lower);
  return byName ? String(byName.iso2).toUpperCase() : null;
}

export function toCountryDropdownOptions(countries) {
  return (countries || []).map((c) => ({
    label: c.name,
    value: c.name,
  }));
}

export function toStateDropdownOptions(states) {
  return (states || []).map((s) => ({
    label: s.name,
    value: s.name,
  }));
}

/** Resolve state ISO code from API state rows + saved state name or code. */
export function resolveStateIso2(statesEntities, stateValue) {
  if (!stateValue || !Array.isArray(statesEntities) || statesEntities.length === 0) {
    return null;
  }
  const raw = String(stateValue).trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  const byName = statesEntities.find(
    (s) => String(s.name).toLowerCase() === lower
  );
  if (byName) return String(byName.iso2).toUpperCase();
  const byCode = statesEntities.find(
    (s) => String(s.iso2).toLowerCase() === lower
  );
  return byCode ? String(byCode.iso2).toUpperCase() : null;
}

export function toCityDropdownOptions(cities) {
  return (cities || []).map((c) => ({
    label: c.name,
    value: c.name,
  }));
}
